import { EntityManager } from "../../components/entityManager";
import { enmControlType, enmPropertyType, IMetadata } from "../../components/entityManager/interfaces";
import { AndFilter, ComparisonFilter, IFilter, InFilter } from "../../components/infrastructure/filtering";
import { IEquipment, IEquipmentItemProps, IEquipmentItemStates } from "./interfaces";

export class EquipmentItem extends EntityManager<IEquipment, IEquipmentItemProps, IEquipmentItemStates>{
    static initMetadata = (): IMetadata => {
        return {
            name: "Equipment",
            title: "تجهیزات",
            Properties: [
                {
                    title: "گروه اصلی",
                    dataIndex: "ParentId",
                    propertyType: enmPropertyType.number,
                    controlType: enmControlType.lookup,
                    filterable: true,
                    width: 200,
                    lookup: {
                        lookupComponent: EquipmentItem,
                        lookupProperty: "Parent",
                        lookupDisplayFields: ["Name"]
                    }
                },
                {
                    title: "نام",
                    dataIndex: "Name",
                    propertyType: enmPropertyType.string,
                    controlType: enmControlType.textbox,
                    filterable: true,
                    width: 150,
                    rules: [{ required: true, message: 'لطفا نام را وارد نمایید' }]
                },
                {
                    title: "نام لاتین",
                    dataIndex: "NameEn",
                    propertyType: enmPropertyType.string,
                    controlType: enmControlType.textbox,
                    filterable: true,
                    width: 150
                },
                {
                    title: "کد",
                    dataIndex: "Code",
                    propertyType: enmPropertyType.number,
                    controlType: enmControlType.numberinput,
                    filterable: true,
                    width: 150,
                    rules: [{ required: true, message: 'لطفا کد را وارد نمایید' }]
                },
                {
                    title: "گروه؟",
                    dataIndex: "IsGroup",
                    propertyType: enmPropertyType.boolean,
                    controlType: enmControlType.checkbox,
                    width: 150
                }
            ]
        }
    }

    componentDidMount() {
        super.componentDidMount();
    }
    componentWillUnmount() {
        super.componentWillUnmount();
    }
    onInitializing() {
        this.searchArea = { columnsPerRow: 2 };
        this.searchable = true;
        this.preparelookupProps = (propName, lookupProps: any) => {
            if (propName === "ParentId")
                (lookupProps as IEquipmentItemProps).params = () => {
                    return { parent: this.props.params && this.props.params()?.parent?.Parent, onlyGroups: true };
                };
            return lookupProps;
        }
        this.originalFilter = () => {
            const filters: IFilter[] = [];

            const params = this.props.params && this.props.params();

            let parentId = params && (params.parent?.IsGroup ? params.parent?.Id : params.parent?.ParentId);
            if (parentId)
                filters.push(ComparisonFilter.Equal<IEquipment>(e => e.ParentId, parentId));
            if (params?.onlySubItems)
                filters.push(ComparisonFilter.Equal<IEquipment>(e => e.IsGroup, false));
            if (params?.onlyGroups)
                filters.push(ComparisonFilter.Equal<IEquipment>(e => e.IsGroup, true));
            if (params?.codes?.length)
                filters.push(new InFilter("Code", params.codes));
            if (filters.length)
                return new AndFilter(filters);
        };
        this.onEntityAdded = (entity) => {
            let equipment = this.props.params && this.props.params().parent;
            if (equipment) {
                entity.ParentId = equipment.Id;
                entity.Parent = equipment;
                entity.ModifiedProperties.push("ParentId");
            }
            return true;
        };
    }
}